import { postAdminRemoveFrontendAddonVersion } from "@/api/admin/frontendAddons";
import { postRemoveFrontendAddonVersion } from "@/api/frontendAddons";
import { getDialogMessages } from "@/components/Dialog/DialogFirestore/helper";
import { useBulkDialog } from "@/components/Dialog/helpers/DialogBulk/hooks";
import { formatFrontendAddonVersionDisplayName } from "@/components/FrontendAddonForm/helpers/frontendAddonVersionDisplay";
import { FrontendAddonVersionRaw } from "@/domain/FrontendAddon";
import React from "react";

export const DialogFrontendAddonVersionBulkAction: React.FC<{
  organizationId: string;
  frontendAddonId: string;
  isAADeveloperOrAbove: boolean;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedBulkVersions: FrontendAddonVersionRaw[];
  setSelectedVersionIds: React.Dispatch<React.SetStateAction<string[]>>;
  fetchFrontendAddonVersions: () => Promise<void>;
  runReloadFrontendAddons?: () => Promise<void>;
}> = ({
  organizationId,
  frontendAddonId,
  isAADeveloperOrAbove,
  isOpen,
  setIsOpen,
  selectedBulkVersions,
  setSelectedVersionIds,
  fetchFrontendAddonVersions,
  runReloadFrontendAddons,
}) => {
  const runBulkAction = async (version: FrontendAddonVersionRaw) => {
    if (isAADeveloperOrAbove) {
      await postAdminRemoveFrontendAddonVersion({
        frontendAddonId,
        FrontendAddonVersionId: version.id,
      });
    } else {
      await postRemoveFrontendAddonVersion({
        organizationId,
        frontendAddonId,
        FrontendAddonVersionId: version.id,
      });
    }
  };

  const bulkMessages = getDialogMessages({
    isSome: true,
    actionType: "delete",
    targetType: "version",
  });

  const { renderBulkDialogs } = useBulkDialog<"id", FrontendAddonVersionRaw>({
    ...bulkMessages.confirm,
    rows: selectedBulkVersions,
    rowKey: "id",
    run: runBulkAction,
    isThemeRed: true,
    renderItem: (version) => (
      <div>{formatFrontendAddonVersionDisplayName(version)}</div>
    ),
    open: isOpen,
    onClose: ({ states }) => {
      setIsOpen(false);
      setSelectedVersionIds(
        states.filter((s) => s.status !== "success").map((s) => s.id)
      );
      if (states.some((s) => s.status !== "waiting")) {
        void runReloadFrontendAddons?.();
        void fetchFrontendAddonVersions();
      }
    },
  });

  return <>{renderBulkDialogs()}</>;
};
